import React from "react";
import { softwareDevelopmentProcessesServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const SoftwareDevelopmentProcessesServiceDetail = () => {
  const data = softwareDevelopmentProcessesServiceData;
  return (
    <>
      <SEO {...seoData.softwareProcesses} />
      <ServiceDetailsInner data={data} />
    </>
  );
};

export default SoftwareDevelopmentProcessesServiceDetail;
